<template>
  <div>
    <section class="py-5">
      <div class="container-fluid">
        <div class="col-12 sliderDetails">
          <p class="movieCat">
            CREATE YOUR OWN SCREENING
            <span class="txt-link">
              <router-link class="ml-4 mr-2" to>Watch Movies on Demand</router-link>
              <!-- <img
                id="tooltip-3"
                src="@/assets/img/svg/info-rd-icon.svg"
                class="rounded-circle"
              /> -->
              <button class="btn btn-danger viewmore-btn mr-4" @click="showModal = true">Know more</button>
            </span>
            <!-- ToolTip -->
            <b-tooltip target="tooltip-3" placement="right">

            </b-tooltip>
            <!-- <span class="link ml-2"><router-link :to="{ name: 'nowShowingList'}">(See All)</router-link></span> -->
          </p>
        </div>
        <div class="row" v-if="OwnScreening.length > 0">
          <div class="col-6 col-md-4 col-lg-3 col-xl-2 mb-4" v-for="(singleMovie, singleMovieIndex) in OwnScreening"
            :key="singleMovieIndex">
            <div class="movieSlider-container mx-auto text-center">
              <div class="img-container">
                <router-link :to="{
                  name: 'createScreen',
                  params: {
                    movie_id: singleMovie.movie_id,
                    content_lang_id: singleMovie.content_lang_id
                  }
                }">
                  <img v-lazy="singleMovie.md_thumbnail_url" alt class="img-fluid mx-auto banner" />
                </router-link>

                <div class="img-logo">
                  <router-link :to="{
                    name: 'createScreen',
                    params: {
                      movie_id: singleMovie.movie_id,
                      content_lang_id: singleMovie.content_lang_id
                    }
                  }">
                    <!-- <img src="@/assets/img/svg/gogo-small-icon.svg" class="img-fluid" /> -->
                  </router-link>
                </div>
              </div>
              <div class="text-center mx-auto pt-2 pt-md-3 movieSliderInfo">
                <p class="mb-0 title">{{ singleMovie.movie_title }}</p>
                <ul class="list-inline mb-0 mInfo">
                  <li class="list-inline-item">{{ singleMovie.mf_name }}</li>
                  <li class="list-inline-item">|</li>
                  <li class="list-inline-item">{{ singleMovie.rating }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row container-fluid" v-if="NextPage && loadingData">
          <div class="col-12 text-center">
            <img src="@/assets/img/loadMore.gif" class="load-more" />
          </div>
        </div>
      </div>
    </section>

    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>

    <!-- SPECIAL SCREENINGS MOVIES SLIDER -->
    <!-- <section class="bg-light py-2">
      <div class="container-fluid my-4">
        <SpecialScreenings />
      </div>
    </section>-->

    <b-modal v-model="showModal" ok-variant="danger">
      <ul>
        <li>Creating your own cinema screening is simple.</li>
        <li>
          Just pick the movie you like from a large library of the movies available.
        </li>
        <li>Complete the booking by selecting</li>
        <br />-A. Private Screening: Book the entire Cinema right now just for yourself.
        <br />-B. Confirmed Screening: Book the minimum tickets and confirm the screening right now
        and Invite your friends.
        <br />
        <li>Your screening is confirmed.</li>
        <li>
          Don’t worry if the screening isn’t confirmed which rarely happens, you get the refund within 48 hours.
        </li>
      </ul>




    </b-modal>
  </div>
</template>


<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";

//   import NowShowing from "@/components/partials/nowShowingSlider.vue";
import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";
import loader from "@/components/partials/loader.vue";
import MainServices from "@/services/mainService.js";
import { URL_BASE, LIMIT } from "@/helper/constants";
//   import OwnScreening from "@/components/partials/OwnScreeningSlider.vue";
//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

export default {
  name: "searchResult",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick,
    loader,
    SpecialScreenings
  },

  data() {
    return {
      showModal: false,
      dateTimeSlider: {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6,
        dots: false,
        responsive: [
          {
            breakpoint: 1900,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 4,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3.1,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2
            }
          }
        ]
      },
      movieSlider: {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5.5,
        slidesToScroll: 4,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      PageNo: 1,
      lastPage: 1,
      NextPage: true,
      OwnScreening: [],
      loadingData: true
    };
  },
  mounted() {
    this.getNowShowingData();
  },
  methods: {
    loadMore: function () {
      if (this.NextPage && this.PageNo > 0) {
        // this.loadingData = false;
        setTimeout(() => {
          this.getNowShowingData();
        }, 1000);
      }
    },
    getNowShowingData: function () {
      let payloadNew = { limit: 500, currentPage: this.PageNo };
      this.loadingData = true
      MainServices.GetCreateOwnShow(payloadNew)
        .then(response => {
          const { data } = response;
          console.log("response", response);
          let uniqueArray = []
          if (data.status && data.Records.data.length > 0) {
            if (this.PageNo > 1) {
              //  this.OwnScreening=[...this.MobileData.NowShowing,...data.Records.data]
              console.log("harhal >>>>>>>>>>")


              let concatOwnScreening = this.OwnScreening.concat(data.Records.data)


              let filterArray = concatOwnScreening.filter((item) => {
                if (!uniqueArray.includes(item.movie_title)) {

                  uniqueArray.push(item.movie_title)
                  return true
                } else {
                  return false
                }
              })

              this.OwnScreening = filterArray




            } else {


              this.lastPage = data.Records.pagination.lastPage;


              let filterArrayOne = data.Records.data.filter((item) => {
                if (!uniqueArray.includes(item.movie_title)) {

                  uniqueArray.push(item.movie_title)
                  return true
                } else {
                  return false
                }
              })

              this.OwnScreening = filterArrayOne

            }

            console.log(this.OwnScreening, "OwnScreening >>>>>>>>>>")
            this.PageNo = this.PageNo + 1;
            this.NextPage = this.lastPage >= this.PageNo;
            // this.loadingData=true;
          }
        })
        .catch(error => {
          console.log("Error", error);
        }).finally(() => {
          this.loadingData = false;
        })

    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pages/createScreenList.vue